/* =========================================================
   Sticky ATC - Change Options Smooth Scroll
========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  const changeOptionsLinks = document.querySelectorAll('.change-options-link');

  changeOptionsLinks.forEach(link => {

    link.addEventListener('click', function(e) {

      e.preventDefault();

const target = document.querySelector(
  '#product-variant-selector, .product-form, .product-options, form[action*="/cart/add"]'
);
      if (target) {

        const offset = 140; // Adjust this number if needed

        const targetPosition =
          target.getBoundingClientRect().top +
          window.pageYOffset -
          offset;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });

      }

    });

  });

});



/* =========================================================
GRIND GUIDE
========================================================= */



(function () {
  function addGrindGuideLink() {
    const possibleLabels = document.querySelectorAll(
      'legend, .form__label, .variant-picker__label, .product-form__input label, fieldset legend'
    );

    possibleLabels.forEach(function (label) {
      const text = label.textContent.trim().toLowerCase();

      if (!text.includes('grind')) return;
      if (label.querySelector('.grind-guide-link')) return;

      const link = document.createElement('a');
      link.href = '#grind-guide';
      link.className = 'grind-guide-link';
      link.textContent = 'Grind guide';

      label.appendChild(link);
    });
  }

  document.addEventListener('DOMContentLoaded', addGrindGuideLink);
  window.addEventListener('load', addGrindGuideLink);

  const observer = new MutationObserver(addGrindGuideLink);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('a[href="#grind-guide"]');
    if (!trigger) return;

    event.preventDefault();

    let drawer = document.querySelector('#grind-guide-drawer');

    if (!drawer) {
      drawer = document.createElement('div');
      drawer.id = 'grind-guide-drawer';
      drawer.innerHTML = `
        <div class="grind-guide-overlay"></div>
        <div class="grind-guide-panel">
          <button type="button" class="grind-guide-close" aria-label="Close">×</button>
          <h2>Grind guide</h2>
          <div class="grind-guide-content">
  <p class="grind-guide-intro">
    <strong>Use this guide to choose the right grind for your brew method.</strong>
  </p>

  <div class="grind-guide-scale">

    <div class="grind-guide-item">
      <span class="grind-icon grind-icon-beans" aria-hidden="true"></span>
      <div class="grind-guide-text">
        <h3>Beans</h3>
        <p>Whole beans — best if you grind at home for maximum freshness.</p>
      </div>
    </div>

    <div class="grind-guide-item">
      <span class="grind-icon grind-icon-espresso" aria-hidden="true"></span>
      <div class="grind-guide-text">
        <h3>Espresso</h3>
        <p>Very fine grind for espresso machines.</p>
      </div>
    </div>

    <div class="grind-guide-item">
      <span class="grind-icon grind-icon-moka" aria-hidden="true"></span>
      <div class="grind-guide-text">
        <h3>Moka Pot</h3>
        <p>Fine grind, slightly coarser than espresso.</p>
      </div>
    </div>

    <div class="grind-guide-item">
      <span class="grind-icon grind-icon-aeropress" aria-hidden="true"></span>
      <div class="grind-guide-text">
        <h3>AeroPress</h3>
        <p>Medium-fine grind, depending on your brew style.</p>
      </div>
    </div>

    <div class="grind-guide-item">
      <span class="grind-icon grind-icon-filter" aria-hidden="true"></span>
      <div class="grind-guide-text">
        <h3>Filter</h3>
        <p>Medium grind for pour-over and filter coffee machines.</p>
      </div>
    </div>

    <div class="grind-guide-item">
      <span class="grind-icon grind-icon-coldbrew" aria-hidden="true"></span>
      <div class="grind-guide-text">
        <h3>Cold Brew</h3>
        <p>Coarse grind for slow steeping and smoother extraction.</p>
      </div>
    </div>

    <div class="grind-guide-item">
      <span class="grind-icon grind-icon-cafetiere" aria-hidden="true"></span>
      <div class="grind-guide-text">
        <h3>Cafetiere</h3>
        <p>Coarse grind, ideal for French press brewing.</p>
      </div>
    </div>

  </div>
</div>
        </div>
      `;
      document.body.appendChild(drawer);
    }

    drawer.classList.add('is-open');
  });

  document.addEventListener('click', function (event) {
    if (
      event.target.matches('.grind-guide-close') ||
      event.target.matches('.grind-guide-overlay')
    ) {
      const drawer = document.querySelector('#grind-guide-drawer');
      if (drawer) drawer.classList.remove('is-open');
    }
  });
})();


/* =========================================================
   SUBSCRIPTION TYPE GUIDE
========================================================= */

(function () {
  const TEMPLATE_SUFFIX = 'office-subscription';
  const DRAWER_ID = 'subscription-type-guide-drawer';

  function isOfficeSubscriptionTemplate() {
    return (
      document.body &&
      document.body.dataset.templateSuffix === TEMPLATE_SUFFIX
    );
  }

  function getLabelText(label) {
    return Array.from(label.childNodes)
      .filter(function (node) {
        return !(
          node.nodeType === Node.ELEMENT_NODE &&
          node.classList &&
          node.classList.contains('subscription-type-guide-link')
        );
      })
      .map(function (node) {
        return node.textContent || '';
      })
      .join(' ')
      .trim()
      .toLowerCase();
  }

  function addSubscriptionTypeGuideLink() {
    if (!isOfficeSubscriptionTemplate()) return;

    const possibleLabels = document.querySelectorAll(
      'legend, .form__label, .variant-picker__label, .product-form__input label, fieldset legend'
    );

    possibleLabels.forEach(function (label) {
      const labelText = getLabelText(label);

      /*
       * Only add the link beside the variant option called "Type".
       * This avoids matching text such as "Coffee type" elsewhere.
       */
      if (labelText !== 'type') return;

      if (label.querySelector('.subscription-type-guide-link')) return;

      const link = document.createElement('a');

      link.href = '#subscription-type-guide';
      link.className = 'subscription-type-guide-link';
      link.textContent = 'Help me choose';
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', DRAWER_ID);

      label.appendChild(link);
    });
  }

  function getSubscriptionTypeGuideDrawer() {
    let drawer = document.querySelector('#' + DRAWER_ID);

    if (drawer) return drawer;

    drawer = document.createElement('div');
    drawer.id = DRAWER_ID;
    drawer.setAttribute('aria-hidden', 'true');

    drawer.innerHTML = `
      <div class="subscription-type-guide-overlay"></div>

      <div
        class="subscription-type-guide-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="subscription-type-guide-title"
        tabindex="-1"
      >
        <button
          type="button"
          class="subscription-type-guide-close"
          aria-label="Close subscription type guide"
        >
          ×
        </button>

        <h2 id="subscription-type-guide-title">
          Help me choose
        </h2>

        <div class="subscription-type-guide-content">
          <p class="subscription-type-guide-intro">
            <strong>
              Choose the option that best matches how you make and enjoy your coffee.
            </strong>
          </p>

          <div class="subscription-type-guide-list">

            <div class="subscription-type-guide-item">
              <span
                class="subscription-type-icon"
                aria-hidden="true"
              >
                <svg
                  viewBox="0 0 64 64"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M15 9h32v20H15z"></path>
                  <path d="M20 14h13v8H20z"></path>
                  <path d="M40 14h2"></path>
                  <path d="M22 29v8"></path>
                  <path d="M39 29v8"></path>
                  <path d="M19 37h23"></path>
                  <path d="M24 37v7"></path>
                  <path d="M37 37v7"></path>
                  <path d="M19 44h23v10H19z"></path>
                  <path d="M47 18h5v22a7 7 0 0 1-7 7h-3"></path>
                </svg>
              </span>

              <div class="subscription-type-guide-text">
                <h3>Espresso</h3>

                <p>
                  A rotating selection of coffees chosen specifically for
                  espresso. Hand-picked by our professional roasters,
                  baristas and trainers to perform beautifully through
                  espresso machines and other espresso brewing equipment.
                </p>
              </div>
            </div>

            <div class="subscription-type-guide-item">
              <span
                class="subscription-type-icon"
                aria-hidden="true"
              >
                <svg
                  viewBox="0 0 64 64"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M18 12h28l-5 24H23z"></path>
                  <path d="M24 19h16"></path>
                  <path d="M29 36v7"></path>
                  <path d="M35 36v7"></path>
                  <path d="M18 43h28"></path>
                  <path d="M21 43v4a8 8 0 0 0 8 8h12"></path>
                  <path d="M41 47h5a4 4 0 0 1 0 8h-5"></path>
                </svg>
              </span>

              <div class="subscription-type-guide-text">
                <h3>Filter</h3>

                <p>
                  A rotating selection chosen for filter brewing, with
                  coffees selected to highlight clarity, sweetness and
                  their individual characteristics. Ideal for pour-over,
                  filter machines and similar filter methods.
                </p>
              </div>
            </div>

            <div class="subscription-type-guide-item">
              <span
                class="subscription-type-icon subscription-type-icon-combined"
                aria-hidden="true"
              >
                <svg
                  viewBox="0 0 64 64"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7 13h22v15H7z"></path>
                  <path d="M11 17h8v6h-8z"></path>
                  <path d="M13 28v7"></path>
                  <path d="M23 28v7"></path>
                  <path d="M10 35h17v9H10z"></path>

                  <path d="M38 13h19l-4 17H42z"></path>
                  <path d="M43 18h10"></path>
                  <path d="M46 30v6"></path>
                  <path d="M50 30v6"></path>
                  <path d="M37 36h21"></path>
                  <path d="M40 36v5a8 8 0 0 0 8 8h7"></path>
                </svg>
              </span>

              <div class="subscription-type-guide-text">
                <h3>Espresso &amp; Filter</h3>

                <p>
                  A versatile rotation for customers who enjoy more than
                  one brewing method. These coffees are selected to work
                  well as espresso while also producing an enjoyable,
                  balanced filter brew.
                </p>
              </div>
            </div>

            <div class="subscription-type-guide-item">
              <span
                class="subscription-type-icon"
                aria-hidden="true"
              >
                <svg
                  viewBox="0 0 64 64"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M12 28h32v13a12 12 0 0 1-12 12h-8a12 12 0 0 1-12-12z"></path>
                  <path d="M44 32h5a7 7 0 0 1 0 14h-6"></path>
                  <path d="M17 57h32"></path>
                  <path d="M27 8a13 13 0 1 0 15 17A15 15 0 0 1 27 8z"></path>
                </svg>
              </span>

              <div class="subscription-type-guide-text">
                <h3>Decaf</h3>

                <p>
Our decaf from smallholder producers in Northern Chiapas, Mexico. Decaffeinated using the Mountain Water Process, a chemical-free method that removes caffeine while preserving the coffee’s natural flavour and character. Smooth, full-bodied and naturally delicious, without the usual caffeine.
                </p>
              </div>
            </div>

            <div class="subscription-type-guide-item">
              <span
                class="subscription-type-icon"
                aria-hidden="true"
              >
                <svg
                  viewBox="0 0 64 64"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M18 14h28l4 40H14z"></path>
                  <path d="M22 14l4-7h12l4 7"></path>
                  <path d="M21 23h22"></path>
                  <path d="M32 28l3 7 8 .7-6 5 2 8-7-4-7 4 2-8-6-5 8-.7z"></path>
                </svg>
              </span>

              <div class="subscription-type-guide-text">
                <h3>Roaster’s Choice</h3>

                <p>
                  Leave the decision to our roasting team. We’ll choose from our range of specialty coffees, selecting a current favourite, seasonal release or coffee we think deserves your attention. Origins, varieties and processes will change, giving you something different to discover with each delivery.
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    `;

    document.body.appendChild(drawer);

    return drawer;
  }

  function openSubscriptionTypeGuide(trigger) {
    const drawer = getSubscriptionTypeGuideDrawer();
    const panel = drawer.querySelector(
      '.subscription-type-guide-panel'
    );

    drawer._lastTrigger = trigger;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add(
      'subscription-type-guide-open'
    );

    window.requestAnimationFrame(function () {
      if (panel) panel.focus();
    });
  }

  function closeSubscriptionTypeGuide() {
    const drawer = document.querySelector('#' + DRAWER_ID);

    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove(
      'subscription-type-guide-open'
    );

    if (
      drawer._lastTrigger &&
      typeof drawer._lastTrigger.focus === 'function'
    ) {
      drawer._lastTrigger.focus();
    }
  }

  function initialiseSubscriptionTypeGuide() {
    if (!isOfficeSubscriptionTemplate()) return;

    addSubscriptionTypeGuideLink();

    const observer = new MutationObserver(function () {
      addSubscriptionTypeGuideLink();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initialiseSubscriptionTypeGuide();
  });

  window.addEventListener('load', function () {
    addSubscriptionTypeGuideLink();
  });

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest(
      'a[href="#subscription-type-guide"]'
    );

    if (trigger) {
      event.preventDefault();
      openSubscriptionTypeGuide(trigger);
      return;
    }

    if (
      event.target.matches('.subscription-type-guide-close') ||
      event.target.matches('.subscription-type-guide-overlay')
    ) {
      closeSubscriptionTypeGuide();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    const drawer = document.querySelector('#' + DRAWER_ID);

    if (drawer && drawer.classList.contains('is-open')) {
      closeSubscriptionTypeGuide();
    }
  });
})();